import PropTypes from 'prop-types'

import Checkbox from 'components/Checkbox'

import FormSection from 'pages/shared/FormSection'

const propTypes = {
  enabled: PropTypes.bool.isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  errors: PropTypes.shape(PropTypes.shape)
}

const defaultProps = {
  errors: {}
}

const SiteBannerFields = ({ enabled, onChangeCallback, errors }) => {
  return (
    <FormSection title="Site Banner">
      <Checkbox
        label="Enabled"
        checked={enabled}
        onChange={() => onChangeCallback({ siteBannerEnabled: !enabled })}
        errorMessage={errors.siteBannerEnabled}
        listId="site-banner"
      />
    </FormSection>
  )
}

SiteBannerFields.propTypes = propTypes
SiteBannerFields.defaultProps = defaultProps

export default SiteBannerFields
